import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
                移动端体验
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 max-w-[480px] mx-auto lg:mx-0">
                {appContent.description}
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
                {appContent.features.map((feat) => (
                  <span
                    key={feat}
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-background-50 border border-background-200/70 rounded-lg text-xs font-medium text-foreground-700"
                  >
                    <i className="ri-check-line text-primary-600"></i>
                    {feat}
                  </span>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 text-sm font-semibold rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill text-lg"></i>
                  App Store 下载
                </a>
                <a
                  href="#"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 text-sm font-semibold rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-fill text-lg"></i>
                  安卓版下载
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center">
              <div className="relative w-full max-w-[320px] aspect-[3/4] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src={appContent.image}
                  alt="樱花动漫91移动端App界面展示"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}